import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledMeasuresContainer = styled.div`
    ${({theme}) => css`
        background: ${theme.palette.neutral['200']};
        height: 100%;
        padding: ${theme.spacing * 5}px;
        overflow: hidden;

        @media (max-width: 768px) {
            padding: 0;
            height: 100%;
        }
    `}
`

export const StyledMeasuresWrapper = styled.div`
    ${({theme}) => css`
        background: ${theme.palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${theme.shadows.sm};
        border: 1px solid ${theme.palette.neutral['200']};
        height: 100%;
        overflow: hidden;

        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr auto;

        @media (max-width: 768px) {
            grid-template-rows: auto 1fr;
            border-radius: 16px;
            height: 100%;
        }
    `}
`

export const StyledContainerTabs = styled(Flexbox)`
    ${({theme}) => css`
        padding: ${theme.spacing * 5}px ${theme.spacing * 6}px ${theme.spacing * 4}px ${theme.spacing * 6}px;

        @media (max-width: 768px) {
            padding: ${theme.spacing * 5}px ${theme.spacing * 4}px;
        }

        @media (max-width: 344px) {
            padding: ${theme.spacing * 5}px ${theme.spacing * 2}px;
        }
    `}
`

export const StyledLink = styled.a`
    ${({theme}) => css`
        color: ${theme.palette.primary['800']};
        text-decoration: underline;
        cursor: pointer;
    `}
`

export const StyledOmissisBadge = styled(Flexbox)`
    ${({theme}) => css`
        background: ${theme.palette.danger['50']};
        color: ${theme.palette.danger['700']};
        padding: ${theme.spacing * 1.5}px ${theme.spacing * 3.5}px;
        border-radius: 16px;
        min-height: 26px;
    `}
`
